import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { DateRangeWithOffset, WeekRanges } from '@pages/booking/types';

type BookingRange = {
    range: DateRangeWithOffset;
    setRange: Dispatch<SetStateAction<DateRangeWithOffset>>;
    weekRanges: WeekRanges;
};

export const BookingRangeContext = createContext<BookingRange>({
    range: { startDate: new Date(), endDate: new Date(), offset: 0 },
    setRange: () => {},
    weekRanges: { rangesByOffset: {}, list: [] },
});

export const useBookingRangeContext = () => {
    return useContext(BookingRangeContext);
};
